import { extendTailwindMerge } from "tailwind-merge";

// cn — merges conditional class names AND resolves Tailwind conflicts, so the class a caller
// passes wins over the component's base class.
//
// It used to concatenate. Tailwind v4 emits `.inline-flex` after `.hidden` in the stylesheet, so a
// caller's `hidden sm:inline-flex` on a Button (whose base is `inline-flex`) never hid anything:
// measured 2026-11-02, the mailbox header showed the theme switch, Mail and Sign out at 320px on
// top of the title, and the account header ran off the screen. Order in the class string means
// nothing to CSS; only a merge that drops the losing class makes the override real.
export type ClassValue = string | number | null | undefined | false | ClassValue[];

const merge = extendTailwindMerge({
  extend: {
    // The token scale's own radius names (tokens.css @theme), so `rounded-card` replaces a base
    // `rounded-[9px]` instead of both applying.
    theme: { radius: ["card", "panel"] },
  },
});

function flatten(inputs: ClassValue[], out: string[]): void {
  for (const input of inputs) {
    if (!input) continue;
    if (Array.isArray(input)) {
      flatten(input, out);
      continue;
    }
    out.push(String(input));
  }
}

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  flatten(inputs, out);
  return merge(out.join(" "));
}
